import { DataTable } from "@/components/data-table";
import { Form, useForm } from "@/components/form";
import { useGetAllClientesQuery } from "@/features/auxiliar/clientes/api/get-all-clientes";
import { formatString } from "@/shared/formats";
import { Cliente } from "@/shared/types/cliente";
import { IconButton, Stack, StackProps } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { useFilters } from "@/components/filters";

interface ClienteSearchProps extends StackProps {
    onClienteSelect?: (cliente: Cliente) => void
}

export default function VentaClienteManualSearch({
    onClienteSelect,
    ...props
}: ClienteSearchProps) {
    const filterData = useFilters({
        useURL: false,
        filters: [
            { type: "string", label: "Nombre", name: "razonSocial" },
            { type: "string", label: "N° Documento", name: "ruc" },
            { type: "string", label: "Email", name: "email" },
            { type: "pagination" }
        ]
    })

    const queryResult = useGetAllClientesQuery(filterData.filterData);

    const filterForm = useForm({
        defaultValues: filterData.filterData,
        onSubmit: ({ value }) => filterData.setFilterData(value),
        closeModalOnSubmit: false,
        submitOnce: false,
    })

    return <Stack minHeight={"70vh"} gap={3} {...props}>
        <Form form={filterForm} direction={"row"} flexWrap={"wrap"} gap={2}>
            <Form.TextField name="razonSocial" label="Nombre" size="small" />
            <Form.TextField name="ruc" label="N° Documento" size="small" />
            <Form.TextField name="email" label="Email" size="small" />
            <Form.SubmitButton>Filtrar</Form.SubmitButton>
        </Form>
        <DataTable flex={1}>
            <DataTable.Content
                fit="flex"
                rows={queryResult.data?.result}
                loading={queryResult.isFetching}
                columns={[
                    { key: "nombre", header: "Nombre", render: row => formatString(row.nombre) },
                    { key: "numDocumento", header: "N° Documento", render: row => row.numDocumento === "0" ? "" : formatString(row.numDocumento) },
                    { key: "telefono", header: "Teléfono", render: row => formatString(row.telefono) },
                    { key: "email", header: "Email", render: row => formatString(row.email) },
                    {
                        header: "", align: "center", width: "auto",
                        render: a => <IconButton onClick={() => onClienteSelect && onClienteSelect(a)}>
                            <AddIcon />
                        </IconButton>
                    }
                ]}
            />
            <DataTable.Pagination queryResult={queryResult} filterData={filterData} />
        </DataTable>
    </Stack>
}